import moment from "moment";

let currDate = new Date();
const getDate = (dayString) => {
    const today = new Date();
    const year = today.getFullYear().toString();
    let month = (today.getMonth() + 1).toString();

    if (month.length === 1) {
        month = "0" + month;
    }

    return dayString.replace("YEAR", year).replace("MONTH", month);
};

const Cal_color_style = {
    white: "#fff",
    blue: "#039be5",
    green: "#0b8043",
    purple: "#4b345fe8",
    orange: "#f18416e8",
    pink: "#f116bfe8",
    dark: "#1c325e",
    brown: "#837362e8",
};

const ConvertEventItemStudent = (data) => {
    currDate = moment(currDate).format("YYYY-MM-DD");
    let events = [];
    if (data) {
        data.map((v) => {
            let objItem = {};
            v.belongs_to = 1;
            objItem.title = v.section_id
                ? v.course
                    ? v.course.coursetitle
                    : "-"
                : v.label;
            objItem.id = v.section_id ? v.section_id : "";
            objItem.start = getDate(v.start_dt);
            objItem.end = getDate(v.end_dt);
            objItem.groupId = JSON.stringify(v);
            objItem.background = '#f9f9f9';
            objItem.border = '#f9f9f9';
            events.push(objItem);
        });
    }

    return events;
};

const ComparingDateJoin = (start_dt, end_dt) => {
  if (!start_dt) return "";

  const startMoment = moment(start_dt);
  const endMoment = end_dt ? moment(end_dt) : null;

  if (!endMoment) {
    return startMoment.format("DD MMM YYYY");
  }

  if (startMoment.isSame(endMoment, 'day')) {
    return `${startMoment.format("DD MMM YYYY")} ${startMoment.format("hh:mm a")} until ${endMoment.format("hh:mm a")}`;
  }

  if (startMoment.isSame(endMoment, 'month')) {
    return `${startMoment.format("DD")} - ${endMoment.format("DD MMM YYYY")} ${startMoment.format("hh:mm a")} until ${endMoment.format("hh:mm a")}`;
  }

  return `${startMoment.format("DD MMM")} - ${endMoment.format("DD MMM YYYY")} ${startMoment.format("hh:mm a")} until ${endMoment.format("hh:mm a")}`;
};

export { ConvertEventItemStudent, ComparingDateJoin }